import React from 'react';
import { Calendar } from 'primereact/calendar';

const ProfileForeignLanguageForm = ({ isOpen, onClose, onSubmit, formData, setFormData, languages = [], isEditing }) => {
    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleDateChange = (name, dateObj) => {
        let dateString = '';
        if (dateObj) {
            const yyyy = dateObj.getFullYear();
            const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
            const dd = String(dateObj.getDate()).padStart(2, '0');
            dateString = `${yyyy}-${mm}-${dd}`;
        }
        handleChange({ target: { name, value: dateString } });
    };

    return (
        <div className="modal-overlay" style={{ zIndex: 1000 }}>
            <div className="modal-box form-modal-box" style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                <div className="modal-header">
                    <h3>{isEditing ? "Cập nhật Trình độ ngoại ngữ" : "Thêm mới Trình độ ngoại ngữ"}</h3>

                    <button
                        type="button"
                        className="close-btn"
                        onClick={onClose}
                        style={{ fontSize: '24px', lineHeight: '1', display: 'flex', alignItems: 'center' }}
                    >
                        &times;
                    </button>
                </div>

                <div className="modal-body" style={{ padding: '25px' }}>
                    <form id="foreignLanguageForm" onSubmit={onSubmit}>
                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngoại ngữ *</label>
                            <select name="LanguageName" className="form-input" value={formData.LanguageName || ''} onChange={handleChange} required>
                                <option value="">Chọn Ngoại ngữ</option>
                                {languages.map((lang) => (
                                    <option key={lang.Id} value={lang.Name}>{lang.Name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="form-grid-2">
                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Chứng chỉ *</label>
                                <input type="text" name="CertificateName" className="form-input" value={formData.CertificateName || ''} onChange={handleChange} required />
                            </div>

                            <div className="form-group">
                                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Xếp loại (điểm) *</label>
                                <input type="text" name="Grade" className="form-input" value={formData.Grade || ''} onChange={handleChange} required />
                            </div>
                        </div>

                        <div className="form-group" style={{ marginBottom: '15px' }}>
                            <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>Ngày cấp *</label>
                            <Calendar
                                id="IssueDate"
                                name="IssueDate"
                                value={(formData.IssueDate && !isNaN(new Date(formData.IssueDate).getTime())) ? new Date(formData.IssueDate) : null}
                                dateFormat="dd/mm/yy"
                                showIcon
                                onChange={(e) => handleDateChange('IssueDate', e.value)}
                                style={{ width: '100%' }}
                                appendTo={document.body}
                                panelStyle={{ marginTop: '5px', boxShadow: '0 4px 15px rgba(0,0,0,0.1)', borderRadius: '8px', zIndex: 99999 }}
                                inputStyle={{ padding: '10px 12px', border: '1px solid #cbd5e1', borderRight: 'none', borderRadius: '6px 0 0 6px', fontSize: '14px', outline: 'none' }}
                                required
                            />
                        </div>
                    </form>
                </div>

                <div className="modal-footer" style={{ borderTop: '1px solid #eee', padding: '15px 25px' }}>
                    <button type="button" className="btn-cancel" onClick={onClose}>Hủy</button>
                    <button type="submit" form="foreignLanguageForm" className="btn-submit">Hoàn tất</button>
                </div>
            </div>
        </div>
    );
};

export default ProfileForeignLanguageForm;